import React, { ChangeEvent, useState, FC } from "react";

// Define the props for the TextArea component
interface TextAreaProps {
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  onChange?: (value: string) => void; // Callback for text change
  rows?: number; // Optional number of rows
  style?: React.CSSProperties; // Optional custom styles
}

const TextArea: FC<TextAreaProps> = ({
  label,
  placeholder,
  defaultValue,
  onChange,
  rows = 4, // Default to 4 rows if not specified
  style,
}) => {
  const [text, setText] = useState(defaultValue || ""); // Manage internal state

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const newText = e.target.value;
    setText(newText); // Update internal state

    if (onChange) {
      onChange(newText); // Pass the updated text to the parent via callback
    }
  };

  return (
    <div className="border border-blue_gray-50_04 p-3.5 rounded-lg">
      {label && <label>{label}</label>} {/* Display label if provided */}
      <textarea
        value={text} // Controlled component
        placeholder={placeholder}
        onChange={handleChange}
        rows={rows} // Use specified rows or default
        className="w-full min-h-16 focus:outline-none text-md" // Apply optional styles
        style={{ resize: "none" }}
      />
    </div>
  );
};

export default TextArea;
